import template from './contact-new.pug';

export const ContactNewComponent = {
  template,
  bindings: {
    resolve: '<',
    modalInstance: '<',
  },
  controller: class ContactNewComponent {
    constructor(Contact, CustomField, ConnectedRecord, RecordGroup, AlertBox, $async, $log) {
      'ngInject';
      this.Contact = Contact;
      this.CustomField = CustomField;
      this.ConnectedRecord = ConnectedRecord;
      this.RecordGroup = RecordGroup;
      this.AlertBox = AlertBox;
      this.$async = $async;
      this.$log = $log;
      this.loadCustomFields = $async(this.loadCustomFields.bind(this));
      this.save = $async(this.save.bind(this));
      this.getGroups = $async(this.getGroups.bind(this));
      this.create = $async(this.create.bind(this));
      this.done = $async(this.done.bind(this));
      this.toggle = this.toggle.bind(this);
      this.updateEmoji = this.updateEmoji.bind(this);
    }

    $onInit() {
      this.step = 'form';
      this.module = 'contact';
      this.loadCustomFields();
      if (this.resolve.contact) {
        this.contact = this.resolve.contact;
      } else {
        this.contact = {
          custom_fields: {}
        };
      }
    }

    async loadCustomFields() {
      try {
        this.cfGroups = await this.CustomField.loadGroups({ module: 'contacts' });
      } catch (e) {
        this.$log.error(e);
      }
    }

    close() {
      this.modalInstance.close(void(0));
    }

    async save({ contact }) {
      try {
        // Step 1: create the contact first
        this.contactAttributes = this.Contact.serialize(contact);
        const newConnectedRecords = angular.copy(contact['new_connected_records']);
        const resp = await this.Contact.create(this.contactAttributes);
        await this.ConnectedRecord.batchCreate(resp.id, newConnectedRecords);

        // Prepare for Step 2: assign to groups
        this.createdContact = resp;
        this.recordId = resp.id;
        await this.getGroups();
        this.prepareGroupStep();
        this.step = 'groups';
      } catch (e) {
        this.$log.error(e);
      }
    }

    prepareGroupStep() {
      // UI helpers for groups step
      this.tabs = ['select', 'create'];
      this.activeTab = this.tabs[0];
      this.maxHeight = window.innerHeight - 300;
      this.maxHeight = this.maxHeight < 200 ? 200 : this.maxHeight;
      this.maxHeight = this.maxHeight > 500 ? 500 : this.maxHeight;

      this.newGroup = {
        name: '',
        emoji: this.RecordGroup.getRandomEmoji(),
        module: this.module,
      };
    }

    toggle(group) {
      group.selected = !group.selected;
    }

    count() {
      return (this.groups || []).filter(group => group.selected).length;
    }

    updateEmoji({ emoji }) {
      this.newGroup.emoji = emoji;
    }

    async create() {
      try {
        const group = await this.RecordGroup.create(this.newGroup);
        (this.groups || []).forEach(g => g.selected = false);
        group.selected = true;
        this.groups.push(group);
        await this.done();
      } catch (e) {
        this.$log.error(e);
      }
    }

    async done() {
      try {
        const selectedGroups = (this.groups || []).filter(group => group.selected);
        if (!selectedGroups.length) {
          this.AlertBox.addMessage('validation_messages.fill_required_fields', { type: 'warning' });
          return;
        }
        const selectedIds = selectedGroups.map(group => group.id);
        await this.RecordGroup.assign(this.recordId, this.module, selectedIds);
        this.AlertBox.addMessage('alert.created', { type: 'success' });
        this.modalInstance.close(this.createdContact);
      } catch (e) {
        this.$log.error(e);
      }
    }

    async getGroups() {
      try {
        const resp = await this.RecordGroup.getList(this.module, {});
        console.log('getGroups', resp);
        // New record has no assigned groups yet
        this.groups = resp || [];
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
